<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "../../../components/widgets/loader";
import Forms from "../../../mixins/Forms";
import Dates from "../../../mixins/Dates";

import axios from 'axios';
import ViewAutomatedReportResultsModal from './view-automated-report-results-modal.vue';

/**
 * View ticket templates component
 */
export default {
  page: {
    title: "All Automated Reports",
    meta: [{name: "description", content: appConfig.description}]
  },
  mixins: [Forms, Dates],
  components: {Layout, PageHeader, Loader, ViewAutomatedReportResultsModal},
  data() {
    return {
      title: "All Automated Reports",
      items: [
        {
          text: "Settings",
          href: "#"
        },
        {
          text: "All Automated Reports",
          active: true
        }
      ],

      isLoading: false,
      automatedReports: null,
      serverErrors: [],

      viewResultsForAutomatedReport: null
    };
  },
  methods: {
    formatFrequency(val) {
      return val.charAt(0).toUpperCase() + val.slice(1);
    },

    attemptViewResultsForAutomatedReport(report) {
      this.viewResultsForAutomatedReport = report;
      this.$bvModal.show('view-automated-report-results-modal');
    },

    loadAutomatedReports() {
      let vm = this;
      vm.isLoading = true;
      axios.get(API_BASE + '/automated-reports/').then(r => {
        vm.isLoading = false;
        vm.automatedReports = r.data;
      }).catch(e => {
        console.log(e);
        vm.isLoading = false;
        vm.setErrors(e);
      });
    }
  },
  created() {
    this.loadAutomatedReports();
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <errors :error-list="serverErrors"></errors>

    <view-automated-report-results-modal :automated-report="viewResultsForAutomatedReport"></view-automated-report-results-modal>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div v-if="isLoading" class="text-center">
              <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
            </div>

            <div v-if="!isLoading" class="table-responsive mb-0">
              <table class="table mb-0 table-centered">
                <thead class="thead-light">
                <tr>
                  <th>#</th>
                  <th>Name</th>
                 <th>Description</th>
                 <th>Frequency</th>
                  <!-- <th>Created At</th> -->
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="report in automatedReports">
                  <th scope="row">{{ report.id }}</th>
                  <td>{{ report.name }}</td>
                 <td>{{ report.description }}</td>
                  <td>{{ formatFrequency(report.frequency) }}</td>
                  <!-- <td>{{ formatDate(report.created_at) }}</td> -->
                  <td class="text-right">
                    <button @click.prevent="attemptViewResultsForAutomatedReport(report)" type="button" class="btn btn-itg btn-sm mr-2">
                      View Results
                    </button>

                    <button
                        type="button"
                        class="btn btn-itg btn-sm"
                        @click="$router.push('/automated-reporting/'+report.id+'/edit')"
                    >
                      Edit
                    </button>
                  </td>
                </tr>
                <tr v-if="automatedReports.length === 0">
                  <th scope="row" colspan="5">
                    <span class="text-danger">No results</span>
                  </th>
                </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>

        <a href="#" class="btn btn-itg-dark"
           @click.prevent="$router.push('/automated-reporting/create')">Create Automated
          Report
        </a>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
